import script from "./useSubTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./useSubTitle.vue?vue&type=script&setup=true&lang=js"

import "./useSubTitle.vue?vue&type=style&index=0&id=5bf6f091&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf6f091"]])

export default __exports__